export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_00.9a0d8d8e.jpg";